import { MenuNavBarItem } from "@/types/common";
import { LogoutIc, SettingIc } from "../Elements";
import { RouteConstant } from "@/routes/routeConstant";

const menuNavBar = ({ isAdmin }: { isAdmin?: boolean }): MenuNavBarItem[] => [
  {
    isCurrentUser: true,
    menu: [
      {
        icon: LogoutIc,
        label: "Log Out",
        isLogout: true,
        href: "/",
      },
      ...(isAdmin
        ? [
            {
              icon: SettingIc,
              label: "Settings",
              href: RouteConstant.Settings,
            },
          ]
        : []),
    ],
  },
  {
    icon: LogoutIc,
    label: "Log out",
    isDesktopNoLabel: true,
    isLogout: true,
  },
];

export default menuNavBar;
